import { render, staticRenderFns } from "./rwskp.vue?vue&type=template&id=2643d656"
import script from "./rwskp.vue?vue&type=script&lang=js"
export * from "./rwskp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports